export const getPercentNum = (count, total) => {
  if (count === 0 && total === 0) {
    return 0
  }

  return Math.round(count / (total / 100))
}
